module.exports = __webpack_public_path__ + "img/icon-dsjxyds.f44d20f5.png";